//dashboard

import { Archive, Clock, Check, FileX, Calendar, Users, FolderOpen, CircleCheck } from 'lucide-react';
import { QuickStatsCard } from '@features/cx/shared/components/QuickStatsCard';
import { Button } from '@shared/ui/button';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@shared/ui/tabs';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import ActiveCycles from './ActiveCycles/ActiveCycles';
import CompletedReadCycles from './CompletedReadCycles';
import { useRemoteUtilityId } from '@shared/selectors/globalSelectors';
import { useValidationBreakSummary } from '../../hooks';
import { ConfigSection } from './ConfigSection';

function ValidationDashboard() {
  const remoteUtilityId = useRemoteUtilityId();
  const { data: summary, isLoading } = useValidationBreakSummary(remoteUtilityId);
  console.log('debug summary', summary);
  const dataTimeLine = summary?.dataTimeline
  // KPI Cards configuration using QuickStatsCard
  const validationKpiCards = [
    {
      title: "Total Readings Collected",
      count: summary?.Total || 0,
      trendSummary: "Total readings received across all active read cycles",
      trendDirection: "up" as const,
      icon: <FolderOpen className="h-8 w-8 text-green-500" />
    },
    {
      title: "Readings Missing",
      count: summary?.PENDING || 0,
      trendSummary: "Readings awaiting collection from field teams",
      trendDirection: "down" as const,
      icon: <Clock className="h-8 w-8 text-blue-500" />
    },
    {
      title: "Readings Validated",
      count: summary?.VALIDATED || 0,
      trendSummary: `${summary?.PERCENTAGES?.VALIDATED || 0}% completion rate`,
      trendDirection: "up" as const,
      icon: <Check className="h-8 w-8 text-green-500" />
    },
    {
      title: "Readings Exempted",
      count: summary?.EXEMPTED || 0,
      trendSummary: `${summary?.PERCENTAGES?.EXEMPTED || 0}% exemption rate`,
      trendDirection: "down" as const,
      icon: <FileX className="h-8 w-8 text-red-500" />
    }
  ];
  const [cycleStats, setCycleStats] = useState({ total: 0, shown: 0 });
  const tabComponents = {
    active: {
      icon: <Users size={14} />,
      label: "Read Cycles Current Runs",
      component: <ActiveCycles  onCycleCountChange={(data) => setCycleStats(data)} />
    },
    completed: {
      icon: <CircleCheck size={14} /> ,
      label: "Read Cycles History Runs",
      component: <CompletedReadCycles />
    },
  };

  // Optional: URL mapping (if you want cleaner URLs)
  const urlMapping = {
    active: "active",
    completed: "completed",
  };

  return (
    <div className='flex flex-col gap-4'>
      <div>
  <div className="flex items-center gap-3">
    <h2 className="page-title">Validation</h2>
  </div>
  <p className="page-subtitle">
    Review and validate meter data for accuracy, completeness, and compliance.
  </p>
</div>
<div className="mb-6 rounded-lg border p-4 grid grid-cols-1 sm:grid-cols-2 gap-3">
          <div className="flex items-center gap-2 text-sm">
            <Calendar className="h-4 w-4" />
            <span className="text-muted-foreground">Data timeline:</span>
            <span className="font-medium">
              {dataTimeLine?.startDate && dataTimeLine?.endDate ? `${dataTimeLine?.startDate} - ${dataTimeLine?.endDate}` : "N/A"}

            </span>
          </div>
          <div className="flex items-center gap-2 text-sm sm:justify-end">
            <Users className="h-4 w-4" />
            <span className="text-muted-foreground">Active cycles shown:</span>
            <span className="font-medium">
              {/* {activeFiltered.length} of {activeCycles.length} */}
              {cycleStats.shown} of {cycleStats.total}
            </span>
          </div>
        </div>
      {/* KPI Summary Cards - Using loop with QuickStatsCard */}
      {isLoading ? (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
          {[...Array(4)].map((_, index) => (
            <div key={index} className="bg-white rounded-lg p-6 shadow-sm animate-pulse">
              <div className="h-4 bg-gray-200 rounded w-3/4 mb-2"></div>
              <div className="h-8 bg-gray-200 rounded w-1/2 mb-2"></div>
              <div className="h-3 bg-gray-200 rounded w-full"></div>
            </div>
          ))}
        </div>
      ) : (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
          {validationKpiCards.map((card, index) => (
            <QuickStatsCard
              key={index}
              title={card.title}
              count={card.count}
              trendSummary={card.trendSummary}
              trendDirection={card.trendDirection}
              icon={card.icon}
            />
          ))}
        </div>
      )}

      <Tabs
        defaultValue="active"
        urlMapping={urlMapping}
        tabComponents={tabComponents}
        tabsListClassName="grid w-full grid-cols-2 gap-2"
        idPrefix="read-cycles-tab"
      />
      <ConfigSection />
    </div>
  );
}

export default ValidationDashboard;